import { useState } from 'react'
import blankButtonStyle from '../../style/BlankButtonStyle';

const HiddenLobbyCode = (props) => {

    const [hover, setHover] = useState(false);

    return <div style={{
        display: 'flex',
        padding: '10px 0px 0px 0px',
        alignItems: 'center',
        fontSize: 'min(calc(10px + 1.5vw), 20px)',
        fontWeight: 'bold'
    }}>
        <span onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            Code:&nbsp;
            <span style={{
                background: hover ? '#FFFFFF' : '#000000',
                borderRadius: '10px',
                transition: 'background 0.15s',
                paddingLeft: '1ch',
                paddingRight: '1ch',
            }}>
                {props.code}
            </span>
        </span>
        <button style={blankButtonStyle} onClick={() => props.copyToClipboard(window.location.href)}>
            <img src={process.env.PUBLIC_URL + '/assets/icons/128/copy.jpg'} alt="copy" style={{ width: "2em" }} className="icon" />
        </button>
    </div>
}

export default HiddenLobbyCode;